module.exports = __webpack_public_path__ + "static/media/Building.f83d8839.jpg";